import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { Card, CardContent } from "@babackapp/ui/components/card";
import useUpdatePortalExchange from "@babackapp/private-api-client/client/use-update-portal-exchange";
import AiSuggestionsForm from "./ai-suggestions-form";

import { z } from "zod";

export const AiSuggestionsFormSchema = z.object({
  shouldShowSizeSuggestions: z.boolean().nullable().optional(),
  shouldShowProductRecommendations: z.boolean().nullable().optional(),
});

export type AiSuggestionsFormValues = z.infer<typeof AiSuggestionsFormSchema>;

/**
 * Suggestion cards of the portal's resolution step. Both settings live on
 * `shop.exchange` (the cards only show when the exchange is offered) and are
 * saved through the same PATCH, with only these two fields.
 */
export default function AiSuggestionsCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: updatePortalExchange } = useUpdatePortalExchange(shop);

  const onSubmit = (values: AiSuggestionsFormValues) => {
    return updatePortalExchange(values);
  };

  return (
    <Card className="w-full">
      <CardContent>
        <AiSuggestionsForm
          onSubmit={onSubmit}
          defaultValues={{
            // null when never set (= on): an untouched switch is saved as null.
            shouldShowSizeSuggestions:
              shop.exchange.shouldShowSizeSuggestions ?? null,
            shouldShowProductRecommendations:
              shop.exchange.shouldShowProductRecommendations ?? null,
          }}
        />
      </CardContent>
    </Card>
  );
}
